import React from 'react'
import injectStyles from 'react-jss'

import styles from './styles.js'

const XeroConnected = ({ classes, isConnected }) => {
  return isConnected ? (
    <div className={classes.connected}>CONNECTED</div>
  ) : (
    <div className={classes.disconnected}>DISCONNECTED</div>
  )
}

export default injectStyles(styles)(XeroConnected)
